import { HttpParams } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ShortenPipe, StripTagsPipe, TrimPipe } from 'ngx-pipes';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpQuery } from './http-query';

@Injectable({
  providedIn: 'root'
})
export class HelpersService {

  constructor(
    private sb: MatSnackBar,
    private shorten: ShortenPipe,
    private strip: StripTagsPipe,
    private trim: TrimPipe,
  ) { 
    this.search$ = new BehaviorSubject('')
  }
  search$: BehaviorSubject<string>
  generateParams(query: HttpQuery): HttpParams {
    const { page, limit, sort, fields, embed, search, filter } = query;
    
    let params = new HttpParams();

    if (page > -1) {
      params = params.append('page', page.toString());
    }
    if (limit > -1) {
      params = params.append('limit', limit.toString());
    }
    if (sort) {
      params = params.append('sort', sort);
    }
    if (fields) {
      params = params.append('fields', fields);
    }
    if (embed) {
      params = params.append('embed', embed);
    }
    if (search) {
      params = this.toHttpParams(query.search, params, 'search')
    }
    if (filter) {
      params = this.toHttpParams(query.filter, params, 'filter');
    }

    return params
  }
  shortIt(text: string): string {
    if (!text) { return '-'; }
    return this.trim.transform(this.shorten.transform(this.strip.transform(text), 36, '...'));
  }
  isBoolean(value): boolean {
    return value === true || value === false;
  }
  toHttpParams(query: any, params: HttpParams, state: string): HttpParams {
    const attributes = Object.keys(query);
    if (attributes.length) {
      if (state == 'filter') {
        attributes.forEach((attribute) => {
          const keys = Object.keys(query[attribute])
          if (keys.length) {
            keys.forEach((key) => {
              if (query[attribute][key] && typeof query[attribute][key] == 'object') {
                const keys = Object.keys(query[attribute][key])
                params = params.append(`${attribute}[${key}][${keys[0]}]`, query[attribute][key][keys[0]])
              } else {
                params = params.append(`${attribute}[${key}]`, query[attribute][key])
              }
            })
          }
        })
      } else {
        params = params.append(`search[${query.fields}]`, query.value)
      }
    }
    if (query.operation) {
      params = params.append('operation', query.operation)
    }
    return params
  }
  
  parseSort(active, direction): string {
    if (active && direction) {
      return `${direction === 'asc' ? '' : '-'}${active}`;
    }
    return null;
  }

  sbError(message: string, action = null, autoClose: boolean | MatSnackBarConfig = true): any {
    return this.sb.open(
      message,
      action ? action : 'Tutup',
      autoClose ? { duration: 5000 } : {}
    )
  }

  sbSuccess(message: string, action = null): any {
    return this.sb.open(
      message,
      action ? action : 'Tutup',
      { duration: 5000 }
    )
  }

  parseRelPath(url: string): string {
    return url ? `${environment.host}/${url}` : '';
  }
}
